import Desktop from './MenuDesktop.vue';
import DesktopDropdown from './MenuDesktopDropdown.vue';
import DesktopItem from './MenuDesktopItem.vue';
import Item from './MenuItem.vue';
import ItemTitle from './MenuItemTitle.vue';
import Mobile from './MenuMobile.vue';

export default {
  Desktop,
  DesktopDropdown,
  DesktopItem,
  Item,
  ItemTitle,
  Mobile,
};
